import useSWR from "swr"
import {API_PROJECTS} from "../constants/apiUrls"

export default function useStProjects(type, page) {
    const url = (type === "my-projects" ? `${API_PROJECTS}?public=false` : type === "recycle-bin" ? `${API_PROJECTS}?deleted=true` : type === "shared-projects" ? `${API_PROJECTS}?public=true` : API_PROJECTS)
    + (page ? `&limit=8&offset=${page === 1 ? 0 : ((page - 1) * 8)}` : "")
    const {data, mutate, error} = useSWR(url, {refreshInterval: 10000})
    return {
        stProjects: data,
        mutateStProjects: mutate,
        isLoadingStProjects: !error && !data,
        isErrorStProjects: error
    }
}